import { createNamedWrapperReducer, isActionRelated } from '@core/utils/state';
import {
    DELIVERY_INTEGRATIONS_FETCH,
    DELIVERY_INTEGRATIONS_FETCHING_SET,
    DELIVERY_INTEGRATIONS_SET,
    DELIVERY_INTEGRATION_VIEWED_SET,
    DELIVERY_ORDERS_FILTERS_SET,
    DELIVERY_ORDERS_SEARCH,
    DELIVERY_ORDERS_SEARCH_MORE,
    DELIVERY_ORDERS_SUMMARY_SET,
    DELIVERY_ORDERS_TRACKING_GROUP_SET,
    DELIVERY_ORDER_CONFIG_FETCH,
    DELIVERY_ORDER_CONFIG_FETCHING_SET,
    DELIVERY_ORDER_FETCHING_SET,
    DELIVERY_ORDER_FOCUSED_SET,
    DELIVERY_ORDER_NEW_SET,
    DELIVERY_ORDER_QUOTE_FETCH,
    DELIVERY_ORDER_QUOTE_FETCHING_SET,
    DELIVERY_ORDER_QUOTE_SET,
    DELIVERY_ORDER_VIEWED_SET,
    DISPATCH_CONFIG_FETCH,
    DISPATCH_CONFIG_FETCHING_SET,
    LIVEVIEW_ORDERS_SEARCH
} from '../action-types';
import { IEntitiesState } from '../shared/entities/entities-state';
import { GROUP_DELIVERY_ORDERS } from '../state-groups';
import { SetDeliveryOrderFetchingAction, SetDeliveryOrdersFiltersAction, SetDeliveryOrdersSummaryAction } from './deliveries-actions';
import {
    IDeliveriesState,
    initialDeliveriesState
} from './deliveries-state';
import { reducer as listReducer } from '../shared/list/reducer';

export function reducer(
    state = initialDeliveriesState(),
    action: any,
    entitySlice: IEntitiesState
): IDeliveriesState {
    switch (action.type) {
        case DELIVERY_ORDERS_SEARCH:
        case LIVEVIEW_ORDERS_SEARCH:
            return {
                ...state,
                orders: {
                    ...state.orders,
                    isFetching: true,
                },
            };

        case DELIVERY_ORDERS_SEARCH_MORE:
            return {
                ...state,
                orders: {
                    ...state.orders,
                    isFetchingMore: true,
                },
            };

        case DELIVERY_ORDER_FETCHING_SET:
            return {
                ...state,
                orders: {
                    ...state.orders,
                    isFetching: (action as SetDeliveryOrderFetchingAction).payload
                        .value,
                },
            };

        case DELIVERY_ORDERS_FILTERS_SET:
            return {
                ...state,
                filters: (action as SetDeliveryOrdersFiltersAction).payload.filters,
            };

        case DELIVERY_ORDERS_SUMMARY_SET:
            return {
                ...state,
                summary: (action as SetDeliveryOrdersSummaryAction).payload.summary,
            };

        case DELIVERY_ORDER_VIEWED_SET:
            return {
                ...state,
                viewedOrderId: action.payload.orderId,
            };

        case DELIVERY_ORDERS_TRACKING_GROUP_SET:
            return {
                ...state,
                tracking: action.payload.tracking,
            };

        case DELIVERY_ORDER_QUOTE_FETCH:
            return {
                ...state,
                isFetchingQuotes: true,
            };

        case DELIVERY_ORDER_QUOTE_SET:
            return {
                ...state,
                quotes: {
                    ...state.quotes,
                    [action.payload.orderId]: action.payload.quotes,
                },
            };

        case DELIVERY_ORDER_QUOTE_FETCHING_SET:
            return {
                ...state,
                isFetchingQuotes: action.payload.value,
            };

        case DELIVERY_INTEGRATIONS_FETCH:
            return {
                ...state,
                isFetchingIntegrations: true,
            };
    
        case DELIVERY_INTEGRATIONS_SET:
            return {
                ...state,
                integrations: {
                    ...state.integrations,
                    ...action.payload.integrations,
                },
            };
    
        case DELIVERY_INTEGRATIONS_FETCHING_SET:
            return {
                ...state,
                isFetchingIntegrations: action.payload.value,
            };

        case DELIVERY_ORDER_NEW_SET:
            return {
                ...state,
                newOrder: action.payload.order,
            };

        case DELIVERY_ORDER_CONFIG_FETCH:
            return {
                ...state,
                isFetchingDeliveryConfig: true
            }

        case DELIVERY_ORDER_CONFIG_FETCHING_SET:
            return {
                ...state,
                isFetchingDeliveryConfig: action.payload.value
            }

        case DISPATCH_CONFIG_FETCH: 
            return {
                ...state,
                isFetchingDispatchConfig: true
            }

        case DISPATCH_CONFIG_FETCHING_SET:
            return {
                ...state,
                isFetchingDispatchConfig: action.payload.value
            }

        case DELIVERY_INTEGRATION_VIEWED_SET:
            return {
                ...state,
                viewedDeliveryIngrationId: action.payload.provider
            }

        case DELIVERY_ORDER_FOCUSED_SET:
            return {
                ...state,
                isOrderOnFocus: action.payload.value
            }
        
        default:
            let nextState: IDeliveriesState = state;

            if (isActionRelated(action, GROUP_DELIVERY_ORDERS)) {
                nextState = {
                    ...state,
                    orders: createNamedWrapperReducer(
                        listReducer,
                        GROUP_DELIVERY_ORDERS
                    )(state.orders, action, entitySlice.entities),
                };
            }

            return nextState;
    }
}